import React, { useEffect, useState } from "react";

import { motion } from "framer-motion";
import { ToastContainer } from "react-toastify";
import SeoHelmet from "@/components/SeoHelmet";
import seoConfig from "@/data/seo.config";

import ConsentManager from "@/modules/frontend/components/ConsentManager";
import PopUp from "@/modules/frontend/components/PopUp";
import BookADemo from "@/modules/frontend/components/BookADemo";

import fImg1 from "@/assets/images/webp/financial-protection-img.webp";
import fImg2 from "@/assets/images/webp/financial-protection-key-highlight-1.webp";
import fImg3 from "@/assets/images/webp/financial-protection-key-highlight-2.webp";
import fImg4 from "@/assets/images/webp/financial-protection-key-highlight-3.webp";
import fImg5 from "@/assets/images/webp/financial-protection-verified-trade-assurance-network.webp";
import fImg6 from "@/assets/images/webp/financial-protection-membership-benefits-global.webp";

const Index = () => {

  const fadeUpVariant = {
    hidden: { opacity: 0, y: 20 },
    visible: (delay = 0) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, delay },
    }),
  };

  const [smallmodalShow, setSmallModalShow] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("en");

  const handleQuoteClick = () => {
    setSmallModalShow(true);
  };

  useEffect(() => {
    setSelectedLanguage(localStorage.getItem("web_lang"));
  }, []);

  return (
    <>
      <SeoHelmet
        title={seoConfig.financialProtection.title}
        description={seoConfig.financialProtection.description}
        keywords={seoConfig.financialProtection.keywords}
        author={seoConfig.financialProtection.author}
      />
      <button
        className="btn outline small sticky-btn"
        onClick={handleQuoteClick}
        type="button"
      >
        Book A Demo
      </button>
      <div >
        <section className="financial-protection">
          {/* inner banner wrape START  */}
          <div className="inner-banner">
            <div className="container">
              {
                selectedLanguage === "en" ? <div className="content-wrape desk-hide">
                  <h2>
                    <motion.span className={`light animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Financial</motion.span>
                    <motion.span className={`blue-text animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    > Trade</motion.span>
                    <motion.span className={`black animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    > Assurance</motion.span>
                  </h2>
                  <motion.p className={`animate-child`}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >Financial Protection for Secure Global Trade</motion.p>
                </div> : <div className="content-wrape desk-hide">
                  <h2>
                    <span className={`light`}>Financial</span>
                    <span className={`blue-text`}> Trade</span>
                    <span className={`black`} > Assurance</span>
                  </h2>
                  <p className={``}>Financial Protection for Secure Global Trade</p>
                </div>
              }

            </div>
          </div>
          {/* inner banner wrape END  */}

          {/* inner page content START */}
          <div className="inner-page-content-wrape global-trade-network-page">
            <div className='container'>
              {
                selectedLanguage === "en" ? <div className="content-wrape mobile-show page-head">
                  <h2 className="mobile-head-text">
                    <motion.span className={`light animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Financial</motion.span>
                    <motion.span className={`blue-text animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    > Trade</motion.span>
                    <motion.span className={`black animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    > Assurance</motion.span>
                  </h2>
                  <motion.p className={`animate-child`}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >Financial Protection for Secure Global Trade</motion.p>
                </div> : <div className="content-wrape mobile-show page-head">
                  <h2 className="mobile-head-text">
                    <span className={`light `}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Financial</span>
                    <span className={`blue-text`}> Trade</span>
                    <span className={`black`}> Assurance</span>
                  </h2>
                  <p className={``}>Financial Protection for Secure Global Trade</p>
                </div>
              }


              <div className="subtext-wrape">
                <div className="row">
                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12">
                    <motion.h1 className={`animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >SECURE GLOBAL TRADE MADE EASY</motion.h1>
                  </div>
                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12">
                    <motion.p className={`medium-size animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Our Financial Protection Program ensures safe, verified transactions, minimizing risks in international trade. With trusted, credible partners, you can confidently expand globally without worrying about payment issues or fraud.</motion.p>
                  </div>
                </div>
              </div>

              <div className='row'>
                <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12'>
                  <div className='img-wrape'>
                    <motion.img src={fImg1} alt='Financial Protection' loading="lazy" className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    ></motion.img>
                  </div>
                </div>
                <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 d-flex align-items-center'>
                  <div className='content-wrape'>
                    <div className="head-text">
                      <motion.h2 className="head animate-child"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        custom={0.1}
                        variants={fadeUpVariant}
                      >
                        Financial Protection
                      </motion.h2>
                    </div>

                    <motion.h6 className="varient animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Trade Confidently, Trade Securely</motion.h6>
                    <motion.p className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >
                      At Orex Trade World Inc, we understand that trust, transparency and transaction security are the cornerstones of successful global trade. Our Financial Protection Program is designed to safeguard every business transaction between verified buyers, suppliers and logistics partners ensuring your international trade operations remain safe, risk-free and reliable.
                    </motion.p>
                    <motion.p className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >
                      Members enjoy up to US $1,00,000 annual coverage under our plan, offering unmatched protection in the global marketplace. This financial assurance is automatically included in Premium and Premium Plus membership empowering businesses to expand confidently while knowing their investments are secure.
                    </motion.p>
                    <motion.p className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >
                      Each partner undergoes a thorough background and financial verification process, so you can trade with verified, credible and trustworthy companies worldwide.
                    </motion.p>
                  </div>
                </div>
              </div>

              {/* verification global network START */}
              <div className="verification-global-wrape" id="transaction-secure">
                <div className="row">
                  <div className="col-xxl-12">
                    <div className="head-text center">
                      <motion.h2 className="head center animate-child"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        custom={0.1}
                        variants={fadeUpVariant}
                      >
                        Transaction Security & Risk Coverage
                      </motion.h2>
                      <motion.p
                        className="animate-child"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        custom={0.1}
                        variants={fadeUpVariant}
                      >Every trade carries risk, but with Orex Trade’s Transaction Security & Risk Coverage, your business is always protected. Our system ensures that each transaction conducted through verified members is backed by comprehensive financial safeguards.</motion.p>

                      <motion.p className="animate-child"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        custom={0.1}
                        variants={fadeUpVariant}
                      >You are covered for up to US $1,00,000 annually, reducing exposure to non-payment and fraudulent activities. This coverage builds confidence for both buyers and suppliers to conduct larger, high-value deals securely.</motion.p>
                    </div>
                  </div>

                  <div className="col-xxl-12">
                    <motion.h5 className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Key Highlights</motion.h5>
                    <div className="row custom-scroll-row">
                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6">
                        <div className="product">
                          <motion.img src={fImg2} alt='Up to US $1,00,000 annual protection' loading="lazy"
                            className="animate-child"
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.1 }}
                            custom={0.1}
                            variants={fadeUpVariant}
                          ></motion.img>
                          <div className="overlays">
                            <motion.p className="animate-child"
                              initial="hidden"
                              whileInView="visible"
                              viewport={{ once: true, amount: 0.1 }}
                              custom={0.1}
                              variants={fadeUpVariant}
                            >Up to US $1,00,000 annual protection</motion.p>
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6">
                        <div className="product">
                          <motion.img src={fImg3} alt='Trade confidently with reduced risk exposure' loading="lazy"
                            className="animate-child"
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.1 }}
                            custom={0.1}
                            variants={fadeUpVariant}
                          ></motion.img>
                          <div className="overlays">
                            <motion.p className="animate-child"
                              initial="hidden"
                              whileInView="visible"
                              viewport={{ once: true, amount: 0.1 }}
                              custom={0.1}
                              variants={fadeUpVariant}
                            >Trade confidently with reduced risk exposure</motion.p>
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6">
                        <div className="product">
                          <motion.img src={fImg4} alt='Ensures smooth, trustworthy cross-border transactions' loading="lazy"
                            className="animate-child"
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.1 }}
                            custom={0.1}
                            variants={fadeUpVariant}
                          ></motion.img>
                          <div className="overlays">
                            <motion.p className="animate-child"
                              initial="hidden"
                              whileInView="visible"
                              viewport={{ once: true, amount: 0.1 }}
                              custom={0.1}
                              variants={fadeUpVariant}
                            >Ensures smooth, trustworthy cross-border transactions</motion.p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* verification global network END */}
            </div>


            {/* globalPartnerwrape START */}
            <div className="global-partner-wrape" id="verified-trade-assurance">
              <div className="img-wrape">
                <motion.img src={fImg5} alt='Verified Trade Assurance Network' loading="lazy" className="animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.1 }}
                  custom={0.1}
                  variants={fadeUpVariant}
                ></motion.img>
              </div>
              <div className="detail-wrape">
                <div className="inner-pad">
                  <div className="head-text">
                    <motion.h2 className="head animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >
                      Verified Trade Assurance Network
                    </motion.h2>
                  </div>
                  <motion.p
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >Trust begins with verification. Every Orex Trade member whether buyer, supplier or logistics partner undergoes a rigorous verification process, including background checks, financial assessments and business credential validation.</motion.p>
                  <motion.p
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >This ensures that your trade partners are authentic, credible and reliable, minimizing the chances of disputes or payment risks. Our verified ecosystem fosters transparency and accountability, making global trade smoother and more dependable for all participants.</motion.p>

                  <motion.h5 className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >Key Highlights</motion.h5>
                  <ul>
                    <motion.li className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}>
                      <i className="sprite"></i>
                      Thorough background and financial checks
                    </motion.li>
                    <motion.li
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >
                      <i className="sprite"></i>
                      Verified global trade network across 80+ countries
                    </motion.li>
                    <motion.li className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >
                      <i className="sprite"></i>
                      Safe, transparent and compliant trade environment
                    </motion.li>
                    <motion.li
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >
                      <i className="sprite"></i>
                      Builds long-term business trust and reliability
                    </motion.li>
                  </ul>
                </div>
              </div>
            </div>
            {/* globalPartnerwrape END */}

            {/* market-inteligence-wrape START */}
            <div className="container market-inteligence-wrape" id="membership-benefits">
              <div className="row">
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <div className="detail-wrape">
                    <div className="inner-pad">
                      <div className="head-text">
                        <motion.h2 className="head animate-child"
                          initial="hidden"
                          whileInView="visible"
                          viewport={{ once: true, amount: 0.1 }}
                          custom={0.1}
                          variants={fadeUpVariant}
                        >
                          Membership Benefits & Global Confidence
                        </motion.h2>
                      </div>
                      <motion.p className="animate-child"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        custom={0.1}
                        variants={fadeUpVariant}
                      >Orex Trade’s Financial Protection isn’t just a policy, it’s a membership advantage. All registered members having Premium and Premium Plus memberships automatically receive financial coverage at no extra cost, empowering businesses to focus on growth rather than risk.</motion.p>

                      <motion.p className="animate-child"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        custom={0.1}
                        variants={fadeUpVariant}
                      >This unique benefit helps you trade with peace of mind, attract reliable partners and establish credibility in the global market. With Orex Trade’s backing, your brand gains trust, confidence and a professional edge, essential for scaling operations and exploring new trade opportunities worldwide.</motion.p>
                      <div className="clearfix"></div>
                      <motion.h5 className="animate-child"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        custom={0.1}
                        variants={fadeUpVariant}
                      >Key Highlights</motion.h5>
                      <ul>
                        <motion.li className="animate-child"
                          initial="hidden"
                          whileInView="visible"
                          viewport={{ once: true, amount: 0.1 }}
                          custom={0.1}
                          variants={fadeUpVariant}
                        >
                          <i className="sprite"></i>
                          Free financial protection included in premium and premium plus membership
                        </motion.li>
                        <motion.li className="animate-child"
                          initial="hidden"
                          whileInView="visible"
                          viewport={{ once: true, amount: 0.1 }}
                          custom={0.1}
                          variants={fadeUpVariant}
                        >
                          <i className="sprite"></i>
                          Builds credibility and global reputation
                        </motion.li>
                        <motion.li className="animate-child"
                          initial="hidden"
                          whileInView="visible"
                          viewport={{ once: true, amount: 0.1 }}
                          custom={0.1}
                          variants={fadeUpVariant}
                        >
                          <i className="sprite"></i>
                          Encourages safe and confident international trade
                        </motion.li>
                        <motion.li className="animate-child"
                          initial="hidden"
                          whileInView="visible"
                          viewport={{ once: true, amount: 0.1 }}
                          custom={0.1}
                          variants={fadeUpVariant}
                        >
                          <i className="sprite"></i>
                          Strengthens partnerships with assured security
                        </motion.li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <motion.img src={fImg6} alt='Membership Benefits & Global Confidence' loading="lazy"
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  ></motion.img>
                </div>
              </div>
            </div>
            {/* market-inteligence-wrape END */}

            {/* gray wrape START */}
            <div className="gray-wrape">
              <div className="container">
                <div className="row">
                  <div className="col-xxl-12">
                    <motion.p
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >With Orex Trade’s Financial Protection Plan, businesses can expand globally without fear of financial loss. Our program ensures every transaction is secure, verified and transparent, fostering a trade environment built on trust and reliability.</motion.p>
                    <motion.p
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Trade Smart. Trade Secure. Trade with Orex Trade.</motion.p>
                  </div>
                </div>
              </div>
            </div>
            {/* gray wrape END */}

          </div>
          {/* inner page content END */}
        </section>
      </div>
      <ConsentManager data={""} />

      {smallmodalShow && (
        <PopUp
          title="Book A Demo"
          smallmodalShow={smallmodalShow}
          setSmallModalShow={setSmallModalShow}
          className="book-demo"
        // onSubmit={handleRegistrationPopup}
        // okButtonLabel={isDemoUser ? 'GO TO INQUIRIES' : isPreKYCUser ? 'GO TO PROFILE' : isViewer ? 'GO TO INQUIRIES' : isEndUser ? 'GO TO INQUIRIES' : 'REGISTER NOW' 
        // }
        >
          <BookADemo
            setSmallModalShow={setSmallModalShow} />
        </PopUp>
      )}
      <ToastContainer />
    </>
  );
};

export default Index;